export default "__VITE_ASSET__CKEcvbz2__"